import React from "react";

import { Body, PageTitle } from "src/components/typography/typography";

import "./not_found.scss";

/*
 * Main
 */

export const NotFoundPage = (): React.ReactElement => {
    return (
        <div className="main-page-wrap page404">
            <div className="center">
                <PageTitle>Error 404</PageTitle>
                <Body>Sorry, the requested page could not be found.</Body>
            </div>
        </div>
    );
};
